module.exports = __webpack_public_path__ + "app/principal/modals/modal-export-invitation-liqAtKk_.html";